import { getAuditDatesList, setAuditDatesList, createAudit, updateAudit, deleteAudit } from "./AuditDatesAction";

const dispatchGetAuditDatesList = (dispatch: Function) => (data: any) => {
  dispatch(getAuditDatesList(data));
};

const dispatchSetAuditDatesList = (dispatch: Function) => (data: any) => {
  dispatch(setAuditDatesList(data));
};

const dispatchCreateAudit = (dispatch: Function) => (data: any) => {
  dispatch(createAudit(data));
};

const dispatchUpdateAudit = (dispatch: Function) => (data: any) => {
  dispatch(updateAudit(data));
};

const dispatchDeleteAudit = (dispatch: Function) => (data: any) => {
  dispatch(deleteAudit(data));
};

export const AuditsDispatch = {
 
    dispatchGetAuditDatesList,
    dispatchSetAuditDatesList,
    dispatchCreateAudit,
    dispatchUpdateAudit,
    dispatchDeleteAudit,
};
